var SetWrapConfig = function (config) {
    this.wrapConfig = config;
    return this;
}

export default SetWrapConfig;